// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card[data-v-dca9ac2a]{\n\tposition: relative;\n\toverflow:hidden;\n}\n.card>iframe[data-v-dca9ac2a]{\n\theight: 100%;\n\twidth:100%;\n}\n.card.padded[data-v-dca9ac2a]{\n\tmargin: 20px;\n}\n.iframe[data-v-dca9ac2a]{\n\tborder:0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
